import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div
      className="flex flex-col items-center justify-center min-h-screen px-4 text-center"
      style={{ background: "#0b0b0f" }}
    >
      <h1
        className="text-6xl sm:text-8xl font-black tracking-tight"
        style={{
          fontFamily: "'Orbitron', sans-serif",
          background: "linear-gradient(90deg, #8a2be2, #ff6a00)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        404
      </h1>
      <p
        className="mt-4 text-xl text-gray-400"
        style={{ fontFamily: "'Space Grotesk', sans-serif" }}
      >
        Page not found
      </p>
      <button
        onClick={() => navigate("/dashboard")}
        className="mt-8 px-6 py-3 rounded-xl font-semibold text-white transition-all hover:opacity-90"
        style={{
          fontFamily: "'Space Grotesk', sans-serif",
          background: "linear-gradient(90deg, #8a2be2, #ff6a00)",
        }}
      >
        ← Back to Dashboard
      </button>
    </div>
  );
}
